/* global Swiper */

// **********************************************************
// Open Demand Modal
// **********************************************************

attachEvent('.open-demand-modal', 'click', (ev) => {
  const parentEle = ev.target.closest('section');
  const demandModal = parentEle.querySelector('.demand-modal');

  if (demandModal) {
    demandModal.classList.add('is-open-modal');
    ev.preventDefault();
  }
});

// **********************************************************
// Open More Modal
// **********************************************************
attachEvent('.open-more-modal, .hardness-info__link', 'click', (ev) => {
  const parentEle = ev.target.closest('section');
  const moreModal = parentEle.querySelector('.more-modal');

  if (moreModal) {
    moreModal.classList.add('is-open-modal');
    ev.preventDefault();
  }
});

// **********************************************************
// Open Size Modal
// **********************************************************

attachEvent('.open-size-modal', 'click', (ev) => {
  const parentEle = ev.target.closest('section');
  const sizeModal = parentEle.querySelector('.size-modal');

  if (sizeModal) {
    sizeModal.classList.add('is-open-modal');
    ev.preventDefault();
  }
});

// **********************************************************
// Open Promotion Modal
// **********************************************************

attachEvent('.open-promotion-modal', 'click', (ev) => {
  const parentEle = ev.target.closest('section');
  const promotionModal = parentEle.querySelector('.promotion-modal');

  if (promotionModal) {
    promotionModal.classList.add('is-open-modal');
    ev.preventDefault();
  }
});

// **********************************************************
// Hardness Tabs
// **********************************************************

attachEvent('[data-hardness-target] label', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-module');
  const dataHardnessEle = ev.target.closest('[data-hardness-target]');
  const dataHardnessTarget = dataHardnessEle.getAttribute('data-hardness-target');
  const dataHardnessContentEle = parentEle.querySelectorAll('[data-hardness], [data-hardness-target]');
  const dataHardnessContentText = parentEle.querySelectorAll('.hardness-info__content-text');
  const currentTab = parentEle.querySelectorAll(`[data-hardness="${dataHardnessTarget}"]`);

  dataHardnessContentText.forEach((contentText) => {
    if (windowWidth() < breakpointMd) {
      slideUp(contentText, 300);
    }
  });

  dataHardnessContentEle.forEach((contentElem) => {
    contentElem.classList.remove('is-active');
    contentElem.classList.remove('is-open');
  });

  currentTab.forEach((currentTabEle) => {
    currentTabEle.classList.add('is-active');
  });

  dataHardnessEle.classList.add('is-active');
});
// **********************************************************
// Hardness Line icons click
// **********************************************************
attachEvent('.hardness-info__item-normal-text', 'click', (ev) => {
  const hardness = document.querySelector(`[data-hardness-target=${ev.target.closest('.hardness-info__item').dataset.hardness}] label`);
  if (hardness) {
    hardness.click();
  }
});

// **********************************************************

// eslint-disable-next-line consistent-return
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

document.addEventListener('DOMContentLoaded', () => {
  const getGTMData = () => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'getGtmData');
    formDataInput.append('lang', localData.lang);
    formDataInput.append('id', localData.id);
    axios
      .post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(JSON.parse(response.data.data.gtm_data));
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const productModule = document.querySelector('.sc-product-module');
  const isCookieBanner = getCookie('cookie_banner_seen');
  const cookieBannersSeenArray = decodeURIComponent(isCookieBanner).split(',');

  if (typeof dataLayer !== 'undefined' &&  productModule && cookieBannersSeenArray.includes('analytics')) {
    getGTMData();
  }

  const customBedSize = document.querySelector('.custom-size-modal__content');
  if (customBedSize) {
    const axiosSendCustomSize = (formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
          const formDataInput = new FormData();
          formDataInput.append('action', formData.action);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('nonce', formData.nonce);
          formDataInput.append('token', token);
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {
                // success
                customBedSize.innerHTML = response.data.data.text;
              }
            })
            .catch((err) => {
              console.error(err);
            });
        });
      });
    };

    const fv = FormValidation.formValidation(customBedSize, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })

      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        if (!e.valid) {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        const formData = {};
        customBedSize.querySelectorAll('input, textarea').forEach((input) => {
          formData[input.name] = input.value.trim();
        });
        axiosSendCustomSize(formData);
      });
  }
});

// **********************************************************
// variables
// **********************************************************
const productPrice = document.querySelector('.product-module__price .product-module__price-current');
const totalPrice = document.querySelector('.final-price__price');
const youSavedWrap = document.querySelector('.price-slashed__wrap');
const slashedPrice = document.querySelector('.price-slashed__wrap .price-slashed');
const priceEl = document.querySelector('.product-module__price');
const youSaved = document.querySelector('.price-slashed__wrap .product-module__price-tax');
const buyButton = document.querySelector('.product-module__add-btn .btn.buy');
const addButton = document.querySelector('.product-module__add-btn .btn');
const itemQuantity = document.querySelector('.product-module__quantity .dropdown__placeholder-text');
const euroSign = totalPrice ? totalPrice.dataset.euro : '';
const crossSellDivs = document.querySelector('.product-module__checkboxes-repeater');
const cartPopup = document.querySelector('.cart-popup');
const pickVoucherWrap = document.querySelector('.product-module__pick-coupon');
const pickVoucherTypeWrap = document.querySelector('.product-module__pick-delivery');
const voucherQuantity = document.querySelector('.product-module__pick-coupon-quantity .dropdown__placeholder-text');
let voucherData;

// **********************************************************
// Product Voucher
// **********************************************************

const setTotalPrice = (price) => {
  if (totalPrice) {
    totalPrice.querySelector('.title--h2').innerHTML = `${price.toFixed(2).replace('.', ',')} €`;
  }
};

const getVoucherVariationIndex = (variations, attr) =>
  variations.findIndex(
    ({ attributes }) =>
      attributes.attribute_price === attr.attributes.attribute_price && attributes.attribute_type === attr.attributes.attribute_type,
  );

const getVoucherVariation = (price, type) => {
  const voucherVariations = JSON.parse(pickVoucherWrap.dataset.vouchervariations);
  voucherData = {
    attributes: {
      attribute_price: price.toString(),
      attribute_type: type,
    },
  };
  addButton.dataset.id = voucherVariations[getVoucherVariationIndex(voucherVariations, voucherData)].variation_id;
};

if (pickVoucherWrap) {
  attachEvent('.pick-coupon .dropdown__list-item', 'click', (ev) => {
    ev.preventDefault();
    const voucherPrice = parseInt(ev.target.control.dataset.price, 10);
    const quantity = parseInt(
      pickVoucherWrap.querySelector('.product-module__pick-coupon-quantity .dropdown__placeholder-text').innerHTML,
      10,
    );
    setTotalPrice(voucherPrice * quantity);
    getVoucherVariation(voucherPrice, pickVoucherTypeWrap.querySelector('input[name="radio-voucher"]:checked').id);
  });
  attachEvent('.product-module__pick-coupon-quantity .dropdown__list-item', 'click', (ev) => {
    ev.preventDefault();
    const voucherPrice = parseInt(pickVoucherWrap.querySelector('.pick-coupon .dropdown__placeholder-text').innerHTML, 10);
    const quantity = parseInt(ev.target.control.dataset.title, 10);
    setTotalPrice(voucherPrice * quantity);
  });
  attachEvent('.radio-button--secondary', 'click', (e) => {
    if (e.target.id) {
      getVoucherVariation(pickVoucherWrap.querySelector('.dropdown__placeholder-text').innerHTML.replace(' €', ''), e.target.id);
    }
  });
}

// **********************************************************
// Product Quantity Price
// **********************************************************
attachEvent('.product-module__quantity .dropdown__list-item', 'click', (ev) => {
  ev.preventDefault();
  let quantityPrice = parseFloat(productPrice.dataset.price.replace(',', '.')) * parseFloat(ev.target.innerHTML);
  document.querySelectorAll('.add-checkbox').forEach((item) => {
    const crossPrice = parseFloat(item.querySelector('input[name="cross-sale"]').dataset.price.replace(',', '.'));
    if (item.querySelector('input[name="cross-sale"]').checked) {
      quantityPrice += crossPrice;
    }
  });
  totalPrice.dataset.price = quantityPrice;
  totalPrice.querySelector('.title--h2').innerHTML = new Intl.NumberFormat('sl-SI', {
    style: 'currency',
    currency: 'EUR',
  }).format(quantityPrice);
});

// **********************************************************
// Product Variation
// **********************************************************
document.addEventListener('DOMContentLoaded', () => {
  const addRemoveDisabled = (filters, data) => {
    filters.forEach((el) => {
      el.parentElement.classList.toggle('disabled', !data.includes(el.dataset.value));
    });
  };

  const axiosAddToCart = (formData) => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'addToCart');
    formDataInput.append('inputs', JSON.stringify(formData));
    formDataInput.append('popupCart', true);
    axios
      .post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // GTM add to cart action
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(JSON.parse(response.data.data.gtm_data));
          }

          const notification = document.querySelector('.cart-popup .cart-popup__notification');
          if (notification) {
            notification.classList.add('is-active');
            notification.querySelector('.title h3').innerText = response.data.data.notification_text;
            setTimeout(() => {
              notification.classList.remove('is-active');
            }, 3000);
          }

          updatePricesAndCartPopup(response.data.data);
          initSideCart();
          updateCartQuantityBadge();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const initBuyButton = () => {
    attachEvent('.product-module__add-btn .btn.buy', 'click', (ev) => {
      const formData = [];
      const crossSellItems = document.querySelectorAll('input[name="cross-sale"]:checked');
      popupProductList.innerHTML = '';
      cartPopup.classList.add('is-cart-open');
      document.body.classList.toggle('noscroll');
      popupProductList.classList.remove('hidden');
      popupCartSummeryEl.classList.remove('hidden');
      popupCartFooterEl.classList.remove('hidden');
      popupCartEmptyEl.classList.add('hidden');
      formData.push({
        id: addButton.dataset.id,
        parent_id: addButton.dataset.parentid,
        // eslint-disable-next-line no-nested-ternary
        quantity: itemQuantity
          ? itemQuantity.innerHTML
          : pickVoucherWrap
          ? pickVoucherWrap.querySelector('.product-module__pick-coupon-quantity .dropdown__placeholder-text').innerHTML
          : 1,
      });
      if (crossSellItems.length) {
        crossSellItems.forEach((item) => {
          formData.push({ id: item.dataset.id, parent_id: item.dataset.parentid, quantity: 1 });
        });
      }
      axiosAddToCart(formData);
    });
  };

  initBuyButton();

  const initModal = () => {
    attachEvent('.product-module__add-btn .btn.open-out-of-stock-modal', 'click', (ev) => {
      const parentEle = ev.target.closest('section');
      const outOfStockModal = parentEle.querySelector('.out-of-stock-modal');
      if (outOfStockModal) {
        outOfStockModal.querySelector('#var_id').value = addButton.dataset.id;
        outOfStockModal.classList.add('is-open-modal');
        ev.preventDefault();
      }
    });
  };

  initModal();

  const populateFields = (response) => {
    const lowestPrice = priceEl.querySelector('.product-module__lowest-price');
    if (response.data.data.text.length) {
      const blueBoxInfo = document.querySelector('.blue-box-info');
      const promotionModal = document.querySelector('.promotion-modal');
      const rightStickers = document.querySelector('.product-slider__stickers--right');
      const leftStickers = document.querySelector('.product-slider__stickers--left');
      const promotionBadgeEl = document.querySelector('.promotion-badge');
      if (blueBoxInfo) {
        blueBoxInfo.remove();
      }
      if (promotionBadgeEl) {
        promotionBadgeEl.remove();
      }
      if (promotionModal) {
        promotionModal.remove();
      }
      if (response.data.data.promotion_box) {
        const promotionBadge = document.createElement('div');
        promotionBadge.innerHTML = response.data.data.promotion_badge;
        document.querySelector('.product-module__info').insertAdjacentHTML('afterend', response.data.data.promotion_box);
        if (rightStickers && rightStickers.childElementCount < 2) {
          promotionBadge.className = 'product-slider__sticker : product-slider__sticker--right promotion-badge';
          rightStickers.appendChild(promotionBadge);
        } else {
          promotionBadge.className = 'product-slider__sticker promotion-badge';
          leftStickers.appendChild(promotionBadge);
        }
      }
      if (response.data.data.promotion_modal) {
        document.querySelector('.sc-general.sc-product-module').insertAdjacentHTML('beforeend', response.data.data.promotion_modal);
      }

      if (lowestPrice) {
        lowestPrice.innerHTML = response.data.data.lowest_price;
      } else {
        const lowestPriceDiv = document.createElement('div');
        lowestPriceDiv.className = 'product-module__lowest-price';
        lowestPriceDiv.innerHTML = response.data.data.lowest_price;
        priceEl.appendChild(lowestPriceDiv);
      }

      const responsePrice = parseFloat(response.data.data.text[0].display_price);
      const responseRegularPrice = response.data.data.text[0].display_regular_price;
      const variationId = response.data.data.text[0].variation_id;
      let totalPriceProduct = responsePrice;
      if (itemQuantity) {
        totalPriceProduct = responsePrice * parseFloat(itemQuantity.innerHTML);
      }
      youSavedWrap.classList.toggle('hidden', responseRegularPrice <= responsePrice);
      productPrice.innerHTML = new Intl.NumberFormat('sl-SI', {
        style: 'currency',
        currency: 'EUR',
      }).format(responsePrice);
      totalPrice.querySelector('.title--h2').innerHTML = new Intl.NumberFormat('sl-SI', {
        style: 'currency',
        currency: 'EUR',
      }).format(totalPriceProduct);
      productPrice.dataset.price = responsePrice;
      totalPrice.dataset.price = totalPriceProduct;
      slashedPrice.innerHTML = responseRegularPrice > responsePrice ? `${getPriceInEuro(responseRegularPrice)}` : '';
      youSaved.innerHTML =
        responseRegularPrice > responsePrice
          ? `${response.data.data.you_saved} <strong>${getPriceInEuro(responseRegularPrice - responsePrice)}</strong>`
          : '';
      addButton.dataset.id = variationId;
      crossSellDivs.innerHTML = response.data.data.cross_sell_items;
      const hardnessFilter = document.querySelectorAll('[name="hardness"]');
      const colorFilter = document.querySelectorAll('[name="colour"]');
      const hardnessEl = document.querySelector(`[data-value="${response.data.data.text[0].attributes.attribute_hardness}"]`);
      const colorEl = document.querySelector(`[data-value="${response.data.data.text[0].attributes.attribute_colour}"]`);
      const stockLabel = document.querySelector('.product-module__delivery');
      if (hardnessEl) {
        hardnessEl.checked = true;
      }
      if (colorEl) {
        colorEl.checked = true;
      }
      addRemoveDisabled(hardnessFilter, response.data.data.hardness_array);
      addRemoveDisabled(colorFilter, response.data.data.color_array);
      if (response.data.data.in_stock) {
        addButton.innerHTML = `<div class="btn__icon"><i class="icon : icon-cart" aria-hidden="true"></i></div><span class="btn__text">${response.data.data.button_text}</span>`;
        addButton.classList.remove('open-out-of-stock-modal');
        addButton.classList.add('buy', 'btn--with-icon');
        stockLabel.classList.toggle('is-hidden', false);
      } else {
        stockLabel.classList.toggle('is-hidden', true);
        addButton.innerHTML = `<span class="btn__text">${response.data.data.button_text}</span>`;
        addButton.classList.remove('buy', 'btn--with-icon');
        addButton.classList.add('open-out-of-stock-modal');
        initModal();
      }
    } else {
      const responseDoesNotExist = response.data.data.product_does_not_exist;
      productPrice.innerHTML = responseDoesNotExist;
      totalPrice.querySelector('.title--h2').innerHTML = responseDoesNotExist;
      productPrice.dataset.price = null;
      totalPrice.dataset.price = null;
      slashedPrice.innerHTML = '';
      lowestPrice.innerHTML = '';
      youSaved.innerHTML = '';
      addButton.dataset.id = null;
      crossSellDivs.innerHTML = '';
    }
  };

  const axiosGetVariationProduct = (formData) => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'getProductVariable');
    formDataInput.append('inputs', JSON.stringify(formData));
    formDataInput.append('id', localData.id);
    axios
      .post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // success
          document.querySelector('.checkboxes-repeater').classList.toggle('is-hidden', !response.data.data.product_in_stock);
          populateFields(response);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const filterProduct = () => {
    const filters = document.querySelectorAll('.radio-filter');
    const formData = {};
    filters.forEach((section) => {
      const inputField = section.querySelector('input:checked');
      if (inputField.name === 'length') {
        formData.attribute_length = inputField.dataset.length;
        formData.attribute_width = inputField.dataset.width;
      } else {
        formData[`attribute_${inputField.name}`] = inputField.dataset.value;
      }
    });
    axiosGetVariationProduct(formData);
  };
  document.querySelectorAll('.product-module__size input, .radio-filter input').forEach((item) => {
    item.addEventListener('click', (event) => {
      filterProduct();
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.parentElement.classList.contains('add-checkbox')) {
      const itemPrice = e.target.parentElement.querySelector('input').dataset.price.replace(',', '.');
      let finalPrice = null;
      if (e.target.parentElement.querySelector('input[name="cross-sale"]').checked) {
        finalPrice = (parseFloat(totalPrice.dataset.price.replace(',', '.')) + parseFloat(itemPrice)).toFixed(2);
      } else {
        finalPrice = (parseFloat(totalPrice.dataset.price.replace(',', '.')) - parseFloat(itemPrice)).toFixed(2);
      }
      totalPrice.dataset.price = finalPrice;
      totalPrice.querySelector('.title--h2').innerHTML = new Intl.NumberFormat('sl-SI', {
        style: 'currency',
        currency: 'EUR',
      }).format(finalPrice);
    }
  });

  const axiosGetCart = () => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'getCart');
    axios
      .post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // success
          // TODO - check cart for cross-sell
          console.log(response);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // TODO - check cart for cross-sell
  attachEvent('.product-module__title', 'click', (ev) => {
    ev.preventDefault();
    axiosGetCart();
  });
});

// **********************************************************
// Wishlist popup
// **********************************************************
function closeProductPopups() {
  const allOpenProductPopups = document.querySelectorAll('.wishlist-popup.is-open');
  allOpenProductPopups.forEach((el) => {
    el.classList.remove('is-open');
  });
}

const openProductPopups = document.querySelectorAll('.product-module__info .wishlist-button');
openProductPopups.forEach((openPopup) => {
  openPopup.addEventListener('click', () => {
    const parent = openPopup.closest('.product-module__info');
    const popup = parent.querySelector('.wishlist-popup');
    const close = popup.querySelector('.wishlist-popup__close');

    if (openPopup.classList.contains('is-active')) {
      closeProductPopups();
      document.body.appendChild(popup);
      popup.classList.remove('added');
      openPopup.classList.add('disabled');
      popup.classList.add('removed');
      popup.classList.add('is-open');

      setTimeout(() => {
        popup.classList.remove('is-open');
        openPopup.classList.remove('disabled');
        parent.appendChild(popup);
      }, 5000);
    } else {
      closeProductPopups();
      document.body.appendChild(popup);
      popup.classList.remove('removed');
      openPopup.classList.add('disabled');
      popup.classList.add('added');
      popup.classList.add('is-open');

      setTimeout(() => {
        popup.classList.remove('is-open');
        openPopup.classList.remove('disabled');
        parent.appendChild(popup);
      }, 5000);
    }

    close.addEventListener('click', () => {
      popup.classList.remove('is-open');
      openPopup.classList.remove('disabled');
      parent.appendChild(popup);
    });
  });
});
